var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5355 1.46447C17.0711 -1.19209e-07 14.714 0 10 0C5.28595 0 2.92893 -1.19209e-07 1.46447 1.46447C-1.19209e-07 2.92893 0 5.28595 0 10C0 14.714 -1.19209e-07 17.0711 1.46447 18.5355C2.92893 20 5.28595 20 10 20C14.714 20 17.0711 20 18.5355 18.5355C20 17.0711 20 14.714 20 10C20 5.28595 20 2.92893 18.5355 1.46447ZM12.0303 6.46967C12.3232 6.76256 12.3232 7.23744 12.0303 7.53033L9.5607 10L12.0303 12.4697C12.3232 12.7626 12.3232 13.2374 12.0303 13.5303C11.7374 13.8232 11.2626 13.8232 10.9697 13.5303L7.96967 10.5303C7.82902 10.3897 7.75 10.1989 7.75 10C7.75 9.8011 7.82902 9.6103 7.96967 9.4697L10.9697 6.46967C11.2626 6.17678 11.7374 6.17678 12.0303 6.46967Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBefore);
export default __webpack_public_path__ + "static/media/before.687328c29aa0fa854e47f55b207478e9.svg";
export { ForwardRef as ReactComponent };